<template>
  <fmv-sidebar type="light" variant="white" class="py-16pt" wheel-propagation>
    <div class="sidebar-heading mb-4" style="font-size: 18px; font-weight: bolder">Filter Interviews</div>

    <div>
      <div class="sidebar-heading">Programs</div>

      <div class="sidebar-block">
        <v-select
          id="program"
          class="form-control v-select-custom"
          label="title"
          v-model="filters.program"
          :reduce="prog => prog.id"
          placeholder="Select program"
          :options="progOptions"
          :loading="filtersLoading"
        >
        </v-select>
      </div>
    </div>
    <div>
      <div class="sidebar-heading">Universities</div>

      <div class="sidebar-block">
        <v-select
          id="university"
          class="form-control v-select-custom"
          label="name"
          v-model="filters.university"
          :reduce="uni => uni.id"
          placeholder="Select university"
          :options="uniOptions"
          :loading="filtersLoading"
        >
        </v-select>
      </div>
    </div>
  </fmv-sidebar>
</template>

<script>
import { FmvSidebar } from 'fmv-layout';
import { truncate, get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'FiltersSidebar',

  components: { FmvSidebar },

  data() {
    return {
      allSimulations: [],
      filters: {
        program: null,
        university: null,
      },
      allPrograms: [],
      universities: [],
      areSimulationsLoading: false,
      uniOptions: [],
      progOptions: [],
      filtersLoading: false,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    ...mapGetters('simulations', ['getSchoolAdmissionSimulationFilters']),
    breadcrumb() {
      return [{ text: this.$t('studentMsgs.students'), active: true }];
    },
  },

  methods: {
    get,
    truncate,
    ...mapActions('simulations', ['getSchoolAdmissionSimulations', 'updateSchoolAdmissionSimulationFilters']),
    ...mapActions('program', ['getAllPublicPrograms']),
    ...mapActions('uni', ['getAllUniversities']),

    async fetchSimulations() {
      this.areSimulationsLoading = true;

      try {
        const response = await this.getSchoolAdmissionSimulations({
          program: this.filters.program,
          university: this.filters.university,
        });
        this.allSimulations = response.data;
      } catch (e) {
        this.makeToast({ variant: 'danger', msg: this.$t('generalMsgs.genErrorMsg') });
      }
      this.areSimulationsLoading = false;
    },
    async fetchFilterOptions() {
      this.filtersLoading = true;
      const response = await this.getAllUniversities({ basic: true });
      this.uniOptions = response.data.length ? response.data : [];
      const resp = await this.getAllPublicPrograms({});
      this.progOptions = resp.data.length ? resp.data : [];
      this.filtersLoading = false;
    },
  },

  watch: {
    filters: {
      deep: true,
      handler(filters) {
        this.updateSchoolAdmissionSimulationFilters({ filters });
      },
    },
  },
  async mounted() {
    this.fetchSimulations();
    this.fetchFilterOptions();
  },
};
</script>
